import React, {CSSProperties, ReactElement, useState, useEffect} from 'react';
import StoreCodeMessage from '../storescan/StoreCodeMessage';
import BarcodeScan from '../storescan/BarcodeScanner';
import {useHistory} from 'react-router-dom';
import {LOGIN_ROUTE_PATH, SPLASH_PATH} from '../../routes/route-constants';
import {setStoreCode, setUserType} from '../../core/localstorage-data';
import useWindowDimensions from '../../core/utils/window.utils';
import {setPageName} from '../../lib/tagmanager';
import {pageName} from '../../lib/constants';
type BarcodeData = {
  barcode: any;
};
const QrScanner: React.FC<BarcodeData> = ({
  barcode,
}: BarcodeData): ReactElement => {
  const navigate = useHistory();
  const [canScan, setCanScan] = useState(true);
  const handleScan = (scanQrcode: string) => {
    setCanScan(false);
    const pathPatternMatcher = new RegExp(
      /https:\/\/[a-zA-Z0-9.]+\.landmarkbuddy\.com\/urlredirect\?id=\w+/,
    );
    const path = scanQrcode;
    const isMatched = pathPatternMatcher.test(path);

    if (isMatched) {
      // console.log('data ' + scanQrcode);
      const data = path.split('?')[1];
      const query = new URLSearchParams(data);

      const storeid = query.get('id');
      // console.log(id);
      if (storeid != null) {
        setStoreCode(storeid);
        navigate.push(SPLASH_PATH);
      }
    }
  };
  const {width} = useWindowDimensions();

  useEffect(() => {
    setPageName(pageName.qrCodePage);
    const userTypeData = 'customer';
    setUserType(userTypeData);
  }, []);

  return (
    <div className="container mx-auto z-10 h-screen w-full bg-blue_three relative p-8">
      <div className="absolute barcode-overlay-content bottom-0 flex-col left-0 right-0 top-0 z-50">
        <div className="flex-grow bg-black_two pt-12 mb-12">
          <StoreCodeMessage
            title1={'Scan any nearby'}
            title2={'Buddy QR code to begin'}
          />
        </div>

        <div className="scanner-container">
          <div className="corners">
            <div className="tops lefts">&nbsp;</div>
            <div className="tops rights">&nbsp;</div>
            <div className="bottoms rights">&nbsp;</div>
            <div className="bottoms lefts">&nbsp;</div>
            <BarcodeScan onScan={handleScan} canScan={canScan} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default QrScanner;
